<template>
    <div class="VideoPlayer" ref="player" @mouseleave="state.cursorText = ''">
            <transition name="fade">
                <!-- Placeholder slot -->
                <div class="VideoPlayer-placeholder" v-show="!launch" @click="onLaunch" @mousemove="setCursorName">
                    <slot></slot>
                </div>
            </transition>
            <video preload="false" disablePictureInPicture :poster="poster" :class="[{'is-show':launch}, 'VideoPlayer__video']" ref="video" :src="url" 
                @click="togglePlay" 
                @dblclick="toggleFullscreen"
                @mousemove="onVideoMouseMove"></video>
            <div ref="controls" class="VideoPlayer__controls grid grid-between nowrap" @mouseover="clearMyTimeout" @mousemove="state.cursorText = ''">
                <div ref="progress" class="VideoPlayer__progress" 
                    @click="handleSeek" 
                    @mousemove="e => mousedown && handleSeek(e)" 
                    @mousedown="mousedown = true"
                    @mouseup="mousedown = false">
                    <div ref="progressBar" class="VideoPlayer__progress__filled"></div>
                </div>
                <div class="VideoPlayer__controls-holder">
                    <button ref="fullscreen" class="VideoPlayer__button toggleFullscreen" title="Toggle Play" @click="toggleFullscreen">{{fullscreenBtn}}</button>
                </div>
            </div>
    </div>
</template>

<script>
import Store from '@/stores/store.js'
import Bus from '@/bus/BusEvent.js'

export default {
    name: 'VideoPlayer',
    props: {
        url: String,
        poster: String,
    },
    data(){
        return {
            state: Store.state,
            countrolsHideTimeout: null,
            mousedown: false,
            launch: false,
            isPlaying: false,
            isfullscreen: false
        }
    },
    created(){
        
    },

    mounted(){
        this.$refs.video.addEventListener("timeupdate", this.handleProgress);
         this.$refs.video.addEventListener("ended", this.onEnded);
         Bus.$on('videoPlay', this.onSomeVideoPlayingEvent );
         this.$refs.video.disablePictureInPicture = true
    },

    methods: {
        onSomeVideoPlayingEvent(url){
            if( url !== this.url ){
                if(typeof this.$refs.video !== 'undefined') {
                    this.$refs.video.pause();         
                    this.checkPlayerStatus();
                }
            }
        },

        onVideoMouseMove(){
            this.toggleControls();
            this.setCursorName();
        },

        onEnded(){
            this.checkPlayerStatus();
            this.setCursorName();
            this.$refs.video.load();  
        },

        checkPlayerStatus(){
            setTimeout(() => {
                if(typeof this.$refs.video !== 'undefined') {
                    this.isPlaying = !this.$refs.video.paused && !this.$refs.video.ended;
                    this.setCursorName();
                }
            }, 100);
        },

        setCursorName(){
            Store.state.cursorText = this.cursorName;
        },

        togglePlay() {
            this.$refs.video.paused ? this.videoPlay() : this.videoPause();
            this.toggleControls();
            this.checkPlayerStatus();
        },

        videoPlay(){
            Bus.$emit('videoPlay', this.url);
            this.$refs.video.play();
        },

        videoPause(){
            if(typeof this.$refs.video !== 'undefined') this.$refs.video.pause()
        },

        handleProgress() {
            if(typeof this.$refs.video !== 'undefined') {
                const percent = this.$refs.video.currentTime / this.$refs.video.duration * 100;
                this.$refs.progressBar.style.flexBasis = `${percent}%`;
            }
        },

        handleSeek(e) {
            const seekTime = e.offsetX / this.$refs.progress.offsetWidth * this.$refs.video.duration;
            this.$refs.video.currentTime = seekTime;
        },

        toggleFullscreen() {
            if( this.isfullscreen == false ){
                if(this.$refs.player.requestFullScreen){
                    this.$refs.player.requestFullScreen();
                }else if(this.$refs.player.webkitRequestFullScreen){
                    this.$refs.player.webkitRequestFullScreen();
                }else if(this.$refs.player.mozRequestFullScreen){
                    this.$refs.player.mozRequestFullScreen();
                }else if(this.$refs.player.msRequestFullScreen){
                    this.$refs.player.msRequestFullScreen();
                }
                this.isfullscreen = true;
            }else{
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                }else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                }else if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                }else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }

                this.isfullscreen = false;
            }
        },

        toggleControls() {
            clearTimeout(this.countrolsHideTimeout);
            this.$refs.controls.classList.add("VideoPlayer__controls--visible");

            this.countrolsHideTimeout = setTimeout(() => {
                if( !!this.$refs.controls ){
                    this.$refs.controls.classList.remove("VideoPlayer__controls--visible");
                }
            }, 3000);
        },

        clearMyTimeout(){
            clearTimeout(this.countrolsHideTimeout);
        },

        onLaunch(){
            this.launch = true;
            this.togglePlay();
        }
    },

    computed: {
        isVideoPlaying(){
            return !!(this.$refs.video.currentTime > 0 && !this.$refs.video.paused && !this.$refs.video.ended && this.$refs.video.readyState > 2)
        },

        cursorName(){
            return this.isPlaying ? 'pause' : 'play';
        },

        fullscreenBtn(){
            return this.isfullscreen ? 'Miniscreen' : 'Fullscreen';
        }
    }
}
</script>


<style scoped lang="scss">

    /* fullscreen */
    html:-ms-fullscreen {
        width: 100%;
    }
    :-webkit-full-screen {
        background-color: transparent;
    }

    .VideoPlayer{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;

        //background-color:red;

        &:fullscreen {
            cursor: auto !important;
            * { cursor: auto !important; }
        }
        &:-ms-fullscreen {
            cursor: auto !important;
            * { cursor: auto !important; }
        }
        &:-moz-full-screen {
            cursor: auto !important;
            * { cursor: auto !important; }
        }
        &:-webkit-full-screen {
            cursor: auto !important;
            * { cursor: auto !important; }
        }

        &-placeholder{
            position: relative;
            height: 100%;
            width: 100%;
        }

        &__button{
            text-align-last: right;
            border: 0;
            background-color: transparent;
            color: #fff;
            text-transform: uppercase;
            &:focus{
                outline: none;
            }
        }

        &__button {
            font-size: 12px;
            line-height: 30px;
        }

        &__video {
            width: 100%;
            height: 100%;
            background-color:#0e0e0E;

            opacity: 0;
            visibility: hidden;
            transition: opacity 0.6s $ease-out-quint;

            &.is-show{
                visibility: visible;
                opacity: 1;
            }
        }

        &__controls {
            position: absolute;
            bottom: 0;
            width: 100%;

            transform: translateY(100%);
            transition: all 0.3s;
            background: rgba(0, 0, 0, 0.8);
            z-index: 2147483647;
            flex-wrap: nowrap;

            &--visible {
                transform: translateY(1px);
            }

            &-holder {
                display: flex;
                align-items: center;
                justify-content: center;
                flex: auto;
            }
        }


        &__progress {
            position: relative;
            display: flex;
            height: 33px;
            transition: height 0.3s;
            background: rgba(0, 0, 0, 0.5);
            width: calc( 100% - 130px );
            
            background-color: rgba( color(white), 0.1);
            
            &__filled {
                width: 50%;
                background-color: color(white);
                flex: 0;
                flex-basis: 0%;
            }
        }

        /* hide controls on fullscreen with WebKit */
        video::-webkit-media-controls {
            display: none !important;
        }
    }


    .fade-enter-active, .fade-leave-active {
       transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

</style>